/*
 * Public API Surface of ecommerce-generico
*/
export * from './class/articulos-general.interface'
export * from './class/promociones-class';
export * from './class/porcentaje-promo.class';
export * from './class/diferencia-promo.class';
export * from './class/monto-calculado-promo';
export * from './class/nxm-promo.class';
export * from './class/combo-promo.class';
export * from './interfaces/promo-item.interface';
export * from './interfaces/categorias-webmenu.interface';
export * from './interfaces/turnos-retiro.interface';
export * from './interfaces/articulos-ecommerce.interface';
export * from './interfaces/images-generic.interface';
export * from './interfaces/sucursales-eccomerce.interface';
export * from './interfaces/usuario.interface';
export * from './interfaces/marcas-ecommerce.interface';
export * from './interfaces/remplazos-ecommerce.interface';
export * from './ecommerce-generico.service';
export * from './interfaces/pedidos-eccomerce.interface';
export * from './interfaces/resultado-busqueda.interface';
export * from './interfaces/historial-ecommerce-mmax';
export * from './order-status.enums';
